var map = {
	"./Food.svg": "441y",
	"./Madhatter1.svg": "f+s0",
	"./Madhatter2svg.svg": "xs5A",
	"./PNG-path1-1.png": "aig8",
	"./Rabbit.gif": "FaTH",
	"./Redarrow1.svg": "QytD",
	"./Redlongarrow1.svg": "ifsd",
	"./Swirl1.svg": "/K60",
	"./card1.jpg": "biyH",
	"./card2.png": "QiQa",
	"./cup-animation.gif": "gNAA",
	"./greenarrow1.svg": "7oB9",
	"./hypno-boy.gif": "2d2e",
	"./multicoloredarrow1.svg": "PSN5",
	"./multicoloredarrow2.svg": "LkjT",
	"./path1-1.svg": "aeZP",
	"./pcb-background.svg": "vaVA",
	"./pinkarrow1.svg": "msnY",
	"./publik.png": "yEhs",
	"./smoke.png": "+1zG",
	"./yellowarrow2svg.svg": "Hj7R"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ikfc";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer ^\.\/.*$
// module id = ikfc
// module chunks = 1